import { urlSettings } from "../app/http-confing/settings/urlSettings";

export const environment = {
  production: true,
  locale: "ar"
};

urlSettings.Settings = {
  apiEndPoint: "api/front",
  apiHost: "www.backend.newfurniture-eg.com",
  // apiPort: 5000,
  apiProtocol: "https",
  language: "ar"
};
